export const RISE_MODE = 'rise'
export const REFERRAL_MODE = 'referral'
export const PROMO_MODE = 'promo'
export const FOUNDERS_MODE = 'founders'
export const MMC_MODE = 'mmc'
